<mat-card *ngIf="teamInfo" class="team-header-card">
  <mat-card-content class="header-content">

    <div class="team-avatar">
      <mat-icon class="avatar-icon">security</mat-icon> </div>

    <div class="team-info">
      <h1 class="team-name">{{ teamInfo.name }}</h1>

      <div class="team-details">
        <div class="detail-item" *ngIf="teamInfo.stadium">
          <mat-icon>stadium</mat-icon>
          <span>{{ teamInfo.stadium }}</span>
        </div>
        <div class="detail-item" *ngIf="teamInfo.location">
          <mat-icon>location_on</mat-icon>
          <span>{{ teamInfo.location }}</span>
        </div>
        <div class="detail-item" *ngIf="teamInfo.category_name">
          <mat-icon>group</mat-icon>
          <span>{{ teamInfo.category_name }}</span>
        </div>
        <div class="detail-item" *ngIf="teamInfo.gender != null">
          <mat-icon *ngIf="teamInfo.gender === 0">male</mat-icon>
          <mat-icon *ngIf="teamInfo.gender === 1">female</mat-icon>
          <span *ngIf="teamInfo.gender === 0">Masculino</span>
          <span *ngIf="teamInfo.gender === 1">Femenino</span>
        </div>
      </div>

      <div class="competitions-list" *ngIf="teamInfo.competitions && teamInfo.competitions.length > 0">
        <span class="competitions-title">Competiciones (histórico):</span>
        <mat-chip-listbox aria-label="Competiciones">
          <mat-chip *ngFor="let comp of teamInfo.competitions">
            {{ comp.name }}
          </mat-chip>
        </mat-chip-listbox>
      </div>
    </div>

  </mat-card-content>
</mat-card>
